import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { CalendarClock } from "lucide-react";
import { DAY_LABELS } from "@/components/DriverScheduleEditor";

const todayIdx = () => {
  const wd = new Intl.DateTimeFormat("en-US", { timeZone: "America/New_York", weekday: "short" }).format(new Date());
  return ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].indexOf(wd);
};

// Read-only weekly schedule for the driver (configured by admin).
export default function DriverScheduleDialog({ open, onOpenChange, schedule, driverName, viewer = "driver" }) {
  const days = schedule?.days || {};
  const hasAny = Object.values(days).some((b) => b && b.length);
  const today = todayIdx();
  const office = viewer === "dispatcher";
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border max-w-sm" data-testid="driver-schedule-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2" style={{ fontFamily: "Manrope" }}>
            <CalendarClock className="w-5 h-5 text-primary" /> {office ? `Horario de ${driverName || "chofer"}` : "Mi horario"}
          </DialogTitle>
          <DialogDescription className="text-xs">
            {office ? "Solo lectura. Se edita desde Administración." : `${driverName ? `${driverName} · ` : ""}Configurado por la oficina. Solo informativo.`}
          </DialogDescription>
        </DialogHeader>
        {!hasAny ? (
          <div className="text-sm text-muted-foreground text-center py-6" data-testid="driver-schedule-empty">
            {office ? "Este chofer aún no tiene horario configurado." : "Aún no tienes un horario configurado. Consulta con la oficina."}
          </div>
        ) : (
          <div className="rounded-md border border-border divide-y divide-border">
            {DAY_LABELS.map((label, d) => {
              const blocks = days[String(d)] || [];
              const isToday = d === today;
              return (
                <div key={d} data-testid={`driver-schedule-day-${d}`}
                  className={`flex items-center gap-3 px-3 py-2 ${isToday ? "bg-primary/10" : ""}`}>
                  <div className={`w-20 text-xs font-bold ${isToday ? "text-primary" : blocks.length ? "text-white" : "text-muted-foreground"}`}>
                    {label}{isToday && <span className="block text-[9px] font-mono tracking-widest">HOY</span>}
                  </div>
                  <div className="flex-1 flex flex-wrap gap-1.5">
                    {blocks.length === 0
                      ? <span className="text-xs text-muted-foreground italic">Libre</span>
                      : blocks.map((b, i) => (
                        <span key={i} className="font-mono text-xs px-2 py-0.5 rounded bg-emerald-500/15 text-emerald-300 border border-emerald-500/30">
                          {b.start} – {b.end}
                        </span>
                      ))}
                  </div>
                </div>
              );
            })}
          </div>
        )}
        {schedule?.note && (
          <div className="text-xs text-amber-300 bg-amber-500/10 border border-amber-500/30 rounded px-3 py-2 uppercase" data-testid="driver-schedule-note">
            {schedule.note}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
